<div class="modal-header justify-content-center">
  <div class="modal-title">How to configure your stream.</div>
</div>
<div class="modal-body">
  <ng-container *ngIf="dialog$ | async as dialog">
    <div class="sub-title">OBS</div>
    <ol class="help">
      <li>Go to OBS Settings</li>
      <li>Go to "Stream" Section</li>
      <li>Choose "Custom..." for Service</li>
      <li>
        Use <span>{{ dialog.initialState.rtmpUrl}}</span> for the RTMP Url
        <span
          id="cl-1"
          class="copy-button"
          [cdkCopyToClipboard]="getText(dialog.initialState.rtmpUrl)"
          (click)="onCopyToClipboard($event, 'cl-1', 'Copy URL')"
        >
          <i class="far fa-copy mr-2"></i>
          <span>Copy URL </span>
        </span>
      </li>
      <li>
        Use the generated stream key: <span> {{ dialog.initialState.streamKey }}</span>  for the Stream Key
        <span
          id="ck-1"
          class="copy-button"
          [cdkCopyToClipboard]="getText(dialog.initialState.streamKey)"
          (click)="onCopyToClipboard($event, 'ck-1', 'Copy key')"
        >
          <i class="far fa-copy mr-2"></i>
          <span>Copy key </span>
        </span>
      </li>
      <li>Save settings</li>
    </ol>

    <div class="sub-title">OBS WebRTC</div>
    <ol class="help">
      <li>Go to OBS WebRTC Settings</li>
      <li>Go to "Stream" Section</li>
      <li>Choose "Millicast-WebRTC" for Service</li>
      <li>
        Use <span>{{ dialog.initialState.streamName}}</span> for the Stream Name
        <span
          id="cl-4"
          class="copy-button"
          [cdkCopyToClipboard]="getText(dialog.initialState.streamName)"
          (click)="onCopyToClipboard($event, 'cl-4', 'Copy Stream Name')"
        >
          <i class="far fa-copy mr-2"></i>
          <span>Copy Stream Name </span>
        </span>
      </li>
      <li>
        Use <span> {{ dialog.initialState.streamKey }}</span> for the Publishing Token
        <span
          id="ck-4"
          class="copy-button"
          [cdkCopyToClipboard]="getText(dialog.initialState.streamKey)"
          (click)="onCopyToClipboard($event, 'ck-4', 'Copy Token')"
        >
          <i class="far fa-copy mr-2"></i>
          <span>Copy Token </span>
        </span>
      </li>
      <li>Tap Apply. Then tap OK.</li>
    </ol>

    <div class="sub-title">Lightstream</div>
    <ol class="help">
      <li>Navigate to Destination Settings in top right corner</li>
      <li>Add a new RTMP destination</li>
      <li>
        Use <span>{{ dialog.initialState.rtmpUrl}}</span> for the Ingest Server Url
        <span
          id="cl-2"
          class="copy-button"
          [cdkCopyToClipboard]="getText(dialog.initialState.rtmpUrl)"
          (click)="onCopyToClipboard($event, 'cl-2', 'Copy URL')"
        >
          <i class="far fa-copy mr-2"></i>
          <span>Copy URL </span>
        </span>
      </li>
      <li>
        Use the generated stream key: <span> {{ dialog.initialState.streamKey }} </span> for the Stream Key
        <span
          id="ck-2"
          class="copy-button"
          [cdkCopyToClipboard]="getText(dialog.initialState.streamKey)"
          (click)="onCopyToClipboard($event, 'ck-2', 'Copy key')"
        >
          <i class="far fa-copy mr-2"></i>
          <span>Copy key </span>
        </span>
      </li>
      <li>Ensure the destination is selected</li>
    </ol>

    <div class="sub-title">StreamYard</div>
    <ol class="help">
      <li>Navigate to the Destinations Section on the left hand side menu</li>
      <li>Add a new Destination and select "Custom RTMP"</li>
      <li>
        Use <span>{{ dialog.initialState.rtmpUrl }}</span> for the Ingest Server Url
        <span
          id="cl-3"
          class="copy-button"
          [cdkCopyToClipboard]="getText(dialog.initialState.rtmpUrl)"
          (click)="onCopyToClipboard($event, 'cl-3', 'Copy URL')"
        >
          <i class="far fa-copy mr-2"></i>
          <span>Copy URL </span>
        </span>
      </li>
      <li>
        Use the generated stream key: <span>{{ dialog.initialState.streamKey }}</span> for the Stream Key
        <span
          id="ck-3"
          class="copy-button"
          [cdkCopyToClipboard]="getText(dialog.initialState.streamKey)"
          (click)="onCopyToClipboard($event, 'ck-3', 'Copy key')"
        >
          <i class="far fa-copy mr-2"></i>
          Copy key
        </span>
      </li>
      <li>Save the destination</li>
      <li>When creating a broadcast, choose the new RTMP destination</li>
    </ol>
  </ng-container>
</div>
